import { forwardRef } from 'react';

// Utils
import { useCalendar } from '@/utils/hooks/scheduler/useCalendar';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import Button from '@/components/base/Button';
// Components
import Icon from '@/components/base/Icon';

export const NavigationButtons = forwardRef((_props, ref) => {
    const { t } = useTranslation('scheduler');
    const { calendarData } = useCalendar();

    return (
        <div className="flex items-center gap-3">
            <Button
                variant="secondary"
                size="sm"
                className="!min-w-fit !rounded-full !px-4"
                onClick={() => {
                    const calendarApi = ref.current.getApi();
                    calendarApi.today();
                }}>
                {t('today')}
            </Button>
            <div className="flex items-center gap-2">
                <button
                    aria-label={t('commons:previous')}
                    className="flex items-center text-icoGray-400 dark:text-icoDarkMode-wolf"
                    onClick={() => {
                        const calendarApi = ref.current.getApi();
                        calendarApi.prev();
                    }}>
                    <Icon icon="chevron-left" />
                </button>
                <button
                    aria-label={t('commons:next')}
                    className="flex items-center text-icoGray-400 dark:text-icoDarkMode-wolf"
                    onClick={() => {
                        const calendarApi = ref.current.getApi();
                        calendarApi.next();
                    }}>
                    <Icon icon="chevron-right" />
                </button>
                <div>{calendarData.title}</div>
            </div>
        </div>
    );
});

NavigationButtons.displayName = 'NavigationButtons';
